import axios from "axios";
import React, { useContext, useMemo } from "react";
import { useSelector } from "react-redux";
import { toastError } from "../../../_utils/toastError";
import { ProfileContext } from "../../../contexts/ProfileContext";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import PDFButton from "../../profile/profileDownloads/PDFButton";
import mUrl from "../../../_utils/mercureUrl";
// import EventsourcePolyfill from "event-source-polyfill";

const DownloadPDFMercure: React.FC<any> = ({
  label,
  button,
  type,
  params,
  variant,
}) => {
  const personId = useSelector((state: any) => state.user.person_id);
  const ctx = useContext(ProfileContext);
  const id = ctx?.peopleData?.id ?? personId;
  const context = useSelector((state: any) => state.auth.context);
  const { t } = useTranslation("common");
  const mercureToken = useSelector((state: any) => state.user.mercure);

  const parameters = useMemo(() => {
    switch (type) {
      case "diag":
        return {
          label: label ?? t("customTests.download"),
          body: {
            type: "test-custom",
            options: {
              "person.id": id,
            },
          },
        };
      case "export-candidates":
        return {
          label: label ?? t("common_advisor.profile.export", { context }),
          body: {
            type: "recruiter-candidates",
            filters: {
              ...params,
            },
          },
        };
      default:
        return {};
    }
  }, [context, id, label, params, t, type]);

  const startDownload = async () => {
    try {
      const { data } = await axios.post("export_files", parameters.body);

      const topic = data.options.topic;

      const mercureUrl = `${mUrl}?topic=${topic}&authorization=${mercureToken}`;

      const eventSource = new EventSource(mercureUrl);

      toast.info(t("notif.download_will_start"));

      eventSource.onmessage = (event: any) => {
        const parsedData = JSON.parse(event.data);
        if (parsedData.status === "done") {
          const link = document.createElement("a");
          link.href = parsedData.fileUrl;
          link.setAttribute("download", "file.pdf");
          document.body.appendChild(link);
          link.click();
          link.parentNode?.removeChild(link);
          eventSource.close();
        } else if (parsedData.status === "error") {
          toastError("errors.failed_download");
          eventSource.close();
        }
      };

      eventSource.onerror = () => {
        toastError("errors.failed_download");
        eventSource.close();
      };
    } catch {
      toastError("errors.failed_download");
    }
  };

  return (
    <>
      {button ? (
        <Button
          variant={variant ?? "contained"}
          sx={{ fontSize: "14px", mt: 1, mb: 1, fontWeight: "normal" }}
          onClick={startDownload}
        >
          {parameters.label}
        </Button>
      ) : (
        <PDFButton
          typeName=""
          token={""}
          fullName=""
          personId={id}
          label={parameters.label}
          type="custom"
          onClick={startDownload}
        />
      )}
    </>
  );
};

export default DownloadPDFMercure;
